// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"CustomSearchBox_searchbox__2uMvr"};